import axios from 'axios';
import httpClient from '@/src/lib/api/http/client';
import { ApplicationError } from '@/src/shared/errors';
import { safeParseZodObject } from '@/src/shared/utils/parser';
import {
  SSubscribeToTopicsRequest,
  TSubscribeToTopicsRequest,
} from '../data/requests';
import { DSubscribeToTopics } from '../dtos';
import { SubscribeToTopicsFailedError } from '../errors';

export const notificationService = {
  async subscribeToTopics({ deviceToken, topics }: DSubscribeToTopics) {
    const requestBody = {
      device_token: deviceToken,
      topics,
    };
    const request = safeParseZodObject<TSubscribeToTopicsRequest>(
      SSubscribeToTopicsRequest,
      requestBody
    );

    try {
      await httpClient.healthyoneMarketplace.post(
        '/notification/subscribe',
        request
      );
    } catch (error) {
      if (axios.isAxiosError(error)) {
        if (!error.response) {
          throw new SubscribeToTopicsFailedError();
        }
        throw new ApplicationError('Error', error.response.data.error.message);
      }

      throw error;
    }
  },
};
